import PropTypes from 'prop-types';
import React, { ReactNode } from 'react';
import { SizeGuideState } from './SizeGuideState';
import SizeGuideContext from './SizeGuideContext';

/**
 * Provider for Size Guide Context.
 */
const SizeGuideProvider = ({
  children,
  businessLine,
}: {
  children: ReactNode;
  businessLine: string;
}) => {
  const initialState: SizeGuideState = {
    productBusinessLine: businessLine,
  };

  return (
    <SizeGuideContext.Provider value={[{ ...initialState }]}>
      {children}
    </SizeGuideContext.Provider>
  );
};

SizeGuideProvider.propTypes = {
  children: PropTypes.element.isRequired,
  businessLine: PropTypes.string.isRequired,
};

export default SizeGuideProvider;
